import { SampleTabBar } from '../sample-tab-bar';
import { Sample } from '../../@types/samples/types';
import styles from './PageHeader.module.css';

export type PageHeaderProps = {
  title: string;
  sample: Sample | null;
  sampleCount: number | null;
  recentSamples?: Sample[];
  onOpen: () => void;
  onSelectRecent?: (sample: Sample) => void;
  onCloseTab?: (sample: Sample) => void;
  wellColorMap?: Record<string, string>;
  actions?: React.ReactNode;
};

const PageHeader = ({
  title,
  sample,
  sampleCount,
  recentSamples,
  onOpen,
  onSelectRecent,
  onCloseTab,
  wellColorMap,
  actions,
}: PageHeaderProps) => (
  <header className={styles.pageHeader}>
    <div className={styles.tabBarWrap}>
      <SampleTabBar
        sample={sample}
        sampleCount={sampleCount}
        recentSamples={recentSamples}
        onOpen={onOpen}
        onSelectRecent={onSelectRecent}
        onCloseTab={onCloseTab}
        wellColorMap={wellColorMap}
      />
    </div>
    {actions ? <div className={styles.actions}>{actions}</div> : null}
  </header>
);

export { PageHeader };
